module.exports = __webpack_public_path__ + "media/src/components/SubscriptionPlans/img/jcb-12ca089767ff33b3013ddb3238bc533b.png";